import * as React from "react";
import { Route, Switch } from "react-router-dom";
import Summary from "./Fraud.MerchantLimitConfigs.Summary";
import List from "./Fraud.MerchantLimitConfigs.List";

const MerchantLimitConfigs = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/fraud/merchant_limit_configs"
      render={routerProps => <List {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/merchant_limit_configs/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default MerchantLimitConfigs;
